import React, { useState, useRef } from 'react';
import { Transition } from '@headlessui/react';
import clsx from 'clsx';

const Tooltip = ({ children, content, placement = 'top' }) => {
  const [show, setShow] = useState(false);
  const timeout = useRef();

  const handleMouseEnter = () => {
    timeout.current = setTimeout(() => setShow(true), 200);
  };

  const handleMouseLeave = () => {
    clearTimeout(timeout.current);
    setShow(false);
  };

  const positionClasses = {
    top: 'bottom-full mb-4 left-1/2 -translate-x-1/2',
    bottom: 'top-full mt-2 left-1/2 -translate-x-1/2',
    left: 'right-full mr-1 top-1/2 -translate-y-1/2',
    right: 'left-full ml-1 top-1/2 -translate-y-1/2',
  };

  const arrowClasses = {
    top: 'bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 rotate-45 origin-center',
    bottom: 'top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 -rotate-45',
    left: 'right-0 top-1/2 -translate-y-1/2 translate-x-1/2 rotate-45',
    right: 'left-0 top-1/2 -translate-y-1/2 -translate-x-1/2 rotate-45',
  };

  return (
    <span
      className="relative"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      {content && content !== '' && (
        <Transition
          show={show}
          enter="transition-opacity duration-150"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            className={clsx(
              'absolute z-50 px-2 py-1 text-sm text-white dark:text-black bg-black dark:bg-white rounded shadow-lg',
              positionClasses[placement]
            )}
          >
            {content}
            {/* Arrow */}
            <div
              className={clsx(
                'absolute w-2 h-2 bg-black dark:bg-white transform',
                arrowClasses[placement]
              )}
            />
          </div>
        </Transition>
      )}
    </span>
  );
};

export default Tooltip;